<template>
  <div
    ref="overlay"
    class="modal-overlay"
    :class="{ active, full }"
  >
    <div class="modal-container">
      <transition
        name="scale-fade"
        @before-enter="active = true"
      >
        <div
            :class="['modal-dialog', size]"
            v-show="active"
        >
          <div class="modal-header" v-if="!full">
            <h2>{{ title }}</h2>

            <span @click.stop="close" v-if="!hideClose">
              <i class="fas fa-times" />
            </span>

          </div>

          <div class="modal-body">
            <slot></slot>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',

  props: {
    size: {
      type: String,
      default: 'med',
    },
    title: String,
    hideClose: Boolean,
    full: Boolean,
  },

  data() {
    return {
      active: false,
    };
  },

  watch: {
    active(val) {
      if (this.$store) {
        this.$store.commit('SET_MODAL_ACTIVE', val);
      }
    },
  },

  methods: {
    open() {
      this.active = true;
    },

    close() {
      this.$emit('onClose');
      this.active = false;
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  $size-sm: px-to-rem(400px);
  $size-med: px-to-rem(600px);
  $size-lg: px-to-rem(800px);
  $size-xl: px-to-rem(1000px);
  $size-fluid: 80%;

  .modal-overlay {
    background-color: $transparent-background;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: none;
    z-index: $zindex-modal;

    &.active {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &.full {
      .modal-dialog {
        padding: 0;
        max-width: px-to-rem(1200px);
        width: 100%;
      }
    }
  }

  .modal-container {
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    text-align: center;
    padding: $gp;

    &:before {
      display: inline-block;
      vertical-align: middle;
      content: " ";
      height: 100%;
    }
  }

  .modal-dialog {
    background-color: $white-color;
    border-radius: $border-radius;
    position: relative;
    box-shadow: $drop-shadow-1;
    margin: 0 auto;
    padding: $gp;

    display: inline-flex;
    flex-direction: column;
    text-align: left;
    vertical-align: middle;
    min-height: auto;
    max-width: 100%;
    width: 100%;
    overflow: visible;

    &.sm {
      max-width: $size-sm;
    }

    &.med {
      max-width: $size-med;
    }

    &.lg {
      max-width: $size-lg;
    }

    &.xl {
      max-width: $size-xl;
    }

    &.fluid {
      max-width: $size-fluid;
    }
  }

  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: $gp;

    h2 {
      margin: 0;
    }

    .fa-times {
      margin-left: $gp;
      font-size: px-to-rem(30px);
    }
  }
</style>
